import React from 'react';
import { Button } from 'react-bootstrap';
import { navigate } from 'gatsby';
// import { Link } from 'gatsby';
import { isLoggedIn } from 'services/auth.api';
import { OptimizedImage } from '../../components/common/OptimizedImage';

// interface BannerProps {
//   mainText?: string;
// }

// const Banner = ({ mainText }: BannerProps) => {
const Banner = () => {
  const onGetStarted = () => {
    navigate('/getstarted/');
  };
  const handleBannerClick = () => {
    navigate('/products/')
  };
  return (
    // <div className="banner banner-image banner-home" data-title="Best dog biscuits NZ online. Dry food by Feed My Furbaby" onClick={handleBannerClick}>
    <div className="banner banner-image banner-home" data-title="Best dog biscuits NZ online. Dry food by Feed My Furbaby">
      {/* <OptimizedImage fileName="bg_banner_3.jpg" /> */}
      <div className="image-overlay"></div>
      <div className="container-fluid">
        <div className="banner-content">
          <h5>The best dog biscuits NZ has to offer, delivered to you.</h5>
          <h2>Your dog deserves the best.<br />You deserve convenience.</h2>
          {!isLoggedIn() && (
            <Button className="btn-def"
              onClick={(event) => {
                event.stopPropagation();
                onGetStarted();
              }}>
              Get Started
            </Button>
          )}
        </div>
      </div>
    </div>




  );
};

export default Banner;
